import { withLatestFrom, map, tap } from 'rxjs/operators';
/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import * as fromRoot from '../../core/reducers';
import * as fromAuth from '@gaia/gaia/login/data-access-login';
import { EventsService } from '../../events/services/events.service';
import { HttpErrorResponse } from '@angular/common/http';

import * as fromUser from '@titan/devkit/user';

@Injectable()
export class AuthEventsEffects {
    constructor(private actions$: Actions, private store: Store<fromRoot.State>, private events: EventsService) {}

    loginSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fromUser.setTitanCookieSuccess),
                tap(() => this.events.loginSuccess())
            ),
        { dispatch: false }
    );

    loginFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fromUser.loginFailed),
                map(action => action.payload),
                tap((err: HttpErrorResponse) => this.events.loginFailure(err.message))
            ),
        { dispatch: false }
    );

    setLocale$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fromUser.setLocale),
                map(({ payload }) => payload),
                withLatestFrom(this.store.pipe(select(fromAuth.getUsername))),
                tap(([locale, username]) => this.events.selectedLocale(username, locale))
            ),
        { dispatch: false }
    );

    loggedOut$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fromUser.logout),
                withLatestFrom(this.store.pipe(select(fromAuth.getUsername))),
                tap(([, username]) => username && this.events.logout(username))
            ),
        { dispatch: false }
    );
}
